import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
import {useMutation} from 'react-query';
import postLabRedesignView from '.';

interface IUsePostLabProps {
  onSuccess?: () => void;
}
const usePostLabRedesign = ({onSuccess}: IUsePostLabProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IStoreLabRedesignView) => {
      return postLabRedesignView(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess();
    },
    onError: (data: AxiosError<IAxiosErr>) => {
      toast.error(data?.response?.data?.message || 'مشکلی پیش آمده است');
    },
  });

  return {isLoadingPostLab: isLoading, mutate, isSuccess};
};

export default usePostLabRedesign;
